/** Abstract class for global aggregating Providers */
export class AbstractGlobalProvider {
    providers = [];
    /** Register a {@link Provider}. If {@link Provider.available} is `false`, registration is skipped. */
    registerProvider(p) {
        if (p.available ?? true) {
            this.providers.push(p);
        }
    }
    /** Whether there are registered **and** available providers */
    hasProviders() {
        return this.providers.length !== 0;
    }
}
